<template>
    <transition name="modal">
        <div class="CmnModal" v-if="showModal">
            <div class="CmnModal__overlay" @click="onClose"></div>
            <div class="CmnModal__wrapper">
                <div class="CmnModal__container">
                    <div class="CmnModal__header__icon">
                        <div class="icon"></div>
                    </div>
                    <div class="CmnModal__header" v-if="hasFreeQuota">
                        <div class="CmnModal__title">Vous avez déjà utilisé <span class="CmnNumber">5</span> contacts clients,</div>
                        <div class="CmnModal__subtitle">Passez au tout illimité<br />en créant votre compte professionnel gratuit !</div>
                    </div>
                    <div class="CmnModal__header" v-else="">
                        <div class="CmnModal__title">Accédez à toutes les fonctionnalités<br /> en vous inscrivant gratuitement.</div>
                    </div>
                    <div class="CmnModal__content">
                        <p class="no-cc-required">* Accès immédiat gratuit, aucune carte de crédit requise</p>
                        <div class="form">
                            <fieldset>
                                <legend>Créer votre compte professionnel *</legend>
                                <input type="text" disabled="disabled" placeholder="Saisissez votre email" v-model="formPro.email" />
                                <p class="help" v-if="!isNegotiator && errors.email">{{ errors.email }}</p>
                                <input type="password" placeholder="Créez votre mot de passe" v-model="formPro.password" />
                                <p class="help" v-if="!isNegotiator && errors.password">{{ errors.password }}</p>
                            </fieldset>
                            <fieldset>
                                <legend>Créer votre compte négociateur *</legend>
                                <input type="text" placeholder="Saisissez votre email" v-model="formNego.email" />
                                <p class="help" v-if="isNegotiator && errors.email">{{ errors.email }}</p>
                                <input type="password" placeholder="Créez votre mot de passe" v-model="formNego.password" />
                                <p class="help" v-if="isNegotiator && errors.password">{{ errors.password }}</p>
                            </fieldset>
                        </div>
                        <label class="checkbox">
                            <input type="checkbox" v-model="cgu" />
                            <span>J'accepte les <a href="/pages/cgu" target="_blank">Conditions Générales d'Utilisation</a></span>
                        </label>
                        <p class="help" v-if="errors.cgucheckbox">{{ errors.cgucheckbox }}</p>
                        <div class="BtnGroup">
                            <button class="CmnBtn" type="button" @click="onSend">
                                <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                                <template v-else="">
                                    <template v-if="!isNegotiator">Créer mon compte pro</template>
                                    <template v-else="">Créer mon compte négociateur</template>
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import axios from 'axios'
    import qs from 'qs'

    export default {
        name: 'cmn-modal',
        data () {
            return {
                showModal: false,
            }
        },
        methods: {
            open () {
                this.showModal = true
            },
            close () {
                this.showModal = false
            },
            onClose () {
                this.close()
            },
        },
    }
</script>

<style lang="sass" scoped>
    @import "./CmnModal"
</style>


// WEBPACK FOOTER //
// application/assets/js/professional/components/CmnModal/CmnModal.vue